import axios from "axios"
import qs from "qs"
import {showToast} from "vant";



// 访问地址配置
// export const baseurl = process.env.NODE_ENV === "production" ? "/" : "http://127.0.0.1:8081/"
 export const baseurl = "/"
// export const baseurl = process.env.NODE_ENV === "production" ? "" : "http://192.168.6.22/"
axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 创建axios实例
const service = axios.create({
  // xsrfHeaderName: "Authorization",
  baseURL: baseurl, // api的base_url
  timeout: 200000 // 请求超时时间 毫秒
})

// request拦截器
service.interceptors.request.use(
    config => {
        window.VuePageApp.showLoading=true
      if (config.method === "get") {
        // 如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2,不转换会显示为arr[]=1&arr[]=2
        config.paramsSerializer = function (params) {
          return qs.stringify(params, { arrayFormat: "repeat" })
        }

      }
      // console.log("localStorage.toke", localStorage.token)
      // if (localStorage.token) {
      //   config.headers["authorization-token"] = localStorage.token // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
      // }
        window.VuePageApp.showLoading=true
        config.withCredentials =true
      return config
    },
    error => {
      // alert(error)
      Promise.reject(error)
    }
)

// respone拦截器
service.interceptors.response.use(
    response => {
        window.VuePageApp.showLoading=false
      // let token = response.headers["authorization-token"]
      // if (token) {
      //   console.log("token", token)
      //   localStorage.setItem("token", token)
      //   console.log("localStorageToken",)
      // }
      // 登录失效处理，本地保存在localStorage
      if (response.data.status != 0) {
        // localStorage.clear()
            showToast(response.data.error.msg)

          if (response.data.status==2) {

              if(location.href.indexOf("/login")==-1){
                  localStorage.setItem("url",location.href)
                  // return
              }

              //判断是微信H5里还是浏览器里
                if (navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1) {
                    let url="./code.html"
                    let parentId=window.H.getParam("parent_id")
                    if(parentId!=null){
                        url+="?parent_id="+parentId
                    }
                    // console.log("url",url)
                    location.href=url
                    return
                }
              //浏览器里则显示二维码用户手机扫二维码进行登录
              setTimeout(function () {
                  location.hash="#/login"
              },1000)
          }
          return response.data
      } else {
        return response.data
      }

    }, // 错误处理
    error => {
      const errorMsg = "err:" + error
      console.log("err" + error, error.response) // for debug
      let data = {}
      // 后台错误
      if (error.response) {
        data = error.response.data
          showToast(error.message)
        return {"status":-1,error:{msg:error.message},data:data}
      }
      // 一般错误
      if (errorMsg.indexOf("timeout") != -1) {
        data.code = 500
        data.message = "请求超时，请稍后再试"
          showToast(error.message)
        return {"status":-1,error:{msg:data.message},data:data}
      }
      //
      if (errorMsg.indexOf("Network Error") != -1) {
        data.code = 500
        data.message = "网络错误，请稍后再试"

        return data
      }
      data.code = 500
      data.message = "" + error
        showToast(error.message)
      return {"status":-1,error:{msg:data.message},data:data}
    }
)

export default service
